import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {IonicModule} from '@ionic/angular';
import {TranslateModule} from '@ngx-translate/core';

import {CModulePage} from './components/cmodule-page/cmodule-page';
import {CModuleRepository} from './repositories/cmodule.repository';
import {CModuleService} from './services/cmodule.service';
import { FormsModule } from '@angular/forms';
import { LeadaComponentsModule } from 'shared/components';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild([
      { path: '', component: CModulePage },
    ]),
    TranslateModule,
    LeadaComponentsModule,
  ],
  providers: [
    CModuleRepository,
    CModuleService,
  ],
  declarations: [
    CModulePage,
  ],
})
export class CModuleModule { }
